<bricks-icon>
  {{ icon }}
</bricks-icon>
<span matSnackBarLabel> {{ message }}</span>
